<template> 
  <project-form :is-edit='false'></project-form>
</template>
<script>
  import ProjectForm from './projectForm'
  export default {
    name: 'projectAdd',
    components: { ProjectForm }
  }
</script>
<style>
</style>


